// extracted by mini-css-extract-plugin
module.exports = {"sampleCard":"__sampleCard__oba2O"};